<script setup>
    import { TweakPane } from '@resn/gozer-vue';
</script>

<template>
    <main id="main">
        <TweakPane>
            <slot />
        </TweakPane>
    </main>
</template>

<style lang="scss" scoped>
    #main {
        min-height: 100vh;
    }
</style>
